import { MISSING_BUCKET_NAME } from "views/Constants";
import { addToQuery, concatQueryStrings, not, predicate } from "views/logic/queries/QueryHelper";
import recordQueryStringUsage from "views/logic/queries/recordQueryStringUsage";
import { updateQueryString } from "views/logic/slices/viewSlice";
import { selectQueryString } from "views/logic/slices/viewSelectors";
import { formatQueryValue, orValuesClause } from "views/logic/valueactions/ValueActionQueryHelper";
export const anyValueClause = (field, values, type) => {
  const presentValues = values.filter((value) => value !== MISSING_BUCKET_NAME);
  const includesMissingBucket = presentValues.length !== values.length;
  const presentValuesClause = presentValues.length === 1 ? predicate(field, formatQueryValue(presentValues[0], type)) : predicate(field, orValuesClause(presentValues.map((value) => ({ value, type }))));
  const clauses = [
    ...presentValues.length > 0 ? [presentValuesClause] : [],
    ...includesMissingBucket ? [predicate(field, MISSING_BUCKET_NAME)] : []
  ];
  const clause = concatQueryStrings(clauses, { operator: "OR", withBrackets: false });
  return clauses.length > 1 ? `(${clause})` : clause;
};
const updateQuery = (queryId, createNewQuery) => async (dispatch, getState) => {
  const oldQuery = selectQueryString(queryId)(getState());
  const newQuery = createNewQuery(oldQuery);
  await recordQueryStringUsage(newQuery, oldQuery);
  return dispatch(updateQueryString(queryId, newQuery));
};
export const addValuesToQuery = ({ queryId, field, values, type }) => updateQuery(queryId, (oldQuery) => addToQuery(oldQuery, anyValueClause(field, values, type)));
export const excludeValuesFromQuery = ({ queryId, field, values, type }) => updateQuery(queryId, (oldQuery) => addToQuery(oldQuery, not(anyValueClause(field, values, type))));
